<block-ui [template]="blockTemplate">
    <app-header> </app-header>
    <section class="feature-medicine-section mt-5" style="background-color: #f2f2f2 0% 0% no-repeat padding-box">
        <div class=" container ">
            <div class="row   justify-content-center">
                <div class=" container mt-2  row">
                    <div class="col-md-12 d-flex pme-tablet">
                        <div class="col-lg-8 col-md-8 col-sm-12 d-flex justify-content-center align-items-end">
                            <div class="text-center text-lg-left">
                                <!-- Título -->
                                <div class="col-sm-12" style="margin-top: 7px; background-color: transparent; margin-bottom: 27px;">
                                    <i class="mr-1 mobile-icon-title">
                                        <img src="../../../../assets/app-assets/images/icones-geia/Grupo-434.png" width="55px">
                                    </i>
                                    <h4 class="ml-5 mobile-title-tipo-empresa mobile-pme" 
                                        style="margin-top: -15px; font-size: 27px; line-height: 0.3; font-weight: 600; padding-left: 5px;">
                                        PME
                                    </h4> 
                                </div>
                        
                                <!-- Texto -->
                                <div class="row align-items-center justify-content-center bg-geia-azul col-sm-12 div-texto-pme" style="height: 130px; border-radius: 20px;">
                                    <h2 class="title">Vamos encontrar o <b>plano ideal para você!</b></h2>
                                    <p class="text-geia text-white m-t-title">
                                        Preencha os dados abaixo para receber um <b>plano personalizado</b> para sua empresa!
                                    </p>
                                </div>    
                            </div>
                        </div>       
                        <!-- Imagem Iris -->
                        <div class="col-lg-4 col-md-4 display-img d-lg-block order-lg-prev">
                            <img src="../../../../assets/app-assets/images/ilustracao/iris-geia-polo.png" alt="Image" class="img-iris">
                        </div>
                    </div>
                    <!-- Formulário -->
                    <div class="card-content" style="max-width: 100%; padding: 0 15px;">
                        <div class="card-body">
                            <form [formGroup]="formGroupPME">
                                <div class="col-12">
                                    <div class="form-group row">
                                        <!-- Nome -->
                                        <div class="form-group mb-1 col-sm-12 col-md-3" style="min-width: 182px;">
                                            <label for="nomeCompleto">Nome da Empresa</label>
                                            <br />
                                            <input 
                                                (ngModelChange)="onFieldChange()" 
                                                type="text" 
                                                class="form-control round" id="nomeCompleto"
                                                maxlength="250" 
                                                formControlName="nomeCompleto" />
                                        </div>
                                        <!-- CNPJ -->
                                        <div class="form-group mb-1 col-sm-12 col-md-3">
                                            <label for="cnpj">CNPJ</label>
                                            <br />
                                            <input 
                                                (ngModelChange)="onFieldChange()"
                                                type="text" 
                                                mask="00.000.000/0000-00"
                                                [showMaskTyped]="true" 
                                                class="form-control round" 
                                                id="cnpj" 
                                                maxlength="250"
                                                formControlName="cnpj"
                                                [ngClass]="{'is-invalid': formGroupPME.controls['cnpj'].errors && isFormSubmited}" />
                                            <div 
                                                *ngIf="formGroupPME.controls['cnpj'].errors?.['required'] && isFormSubmited"
                                                class="invalid-feedback">
                                                Cnpj obrigatório!
                                            </div>
                                            <div 
                                                *ngIf="formGroupPME.controls['cnpj'].errors && isFormSubmited" class="invalid-feedback">
                                                Informe um CNPJ válido!
                                            </div>
                                        </div>                            
                                        <!-- Responsável -->
                                        <div class="form-group mb-1 col-sm-12 col-md-3">
                                            <label for="responsavelProposta">Responsável</label>
                                            <input 
                                                (ngModelChange)="onFieldChange()" 
                                                type="text" 
                                                class="form-control round" 
                                                id="responsavelProposta"
                                                maxlength="250" 
                                                formControlName="responsavelProposta" />
                                        </div>
                                        <!-- Celular -->
                                        <div class="form-group col-md-3 col-sm-12 mb-2">
                                            <label for="contato">Celular</label>
                                            <input 
                                                mask="(00) 00000-0000" 
                                                [showMaskTyped]="true"
                                                class="round box-shadow-4 form-control" 
                                                formControlName="contato" 
                                                type="text"
                                                (ngModelChange)="onFieldChange()" 
                                                [required]="condionalDeObrigatoriedadeContatos()"
                                                [ngClass]="{'is-invalid': formGroupPME.controls['contato'].errors && isFormSubmited}" />
                                            <div 
                                                *ngIf="formGroupPME.controls['contato'].errors?.['required'] && isFormSubmited"
                                                class="invalid-feedback">
                                                Campo obrigatório
                                            </div>
                                        </div>
                                        <!-- Email -->
                                        <div class="form-group mb-1 col-sm-12 col-md-3">
                                            <label for="email">E-mail </label>
                                            <input 
                                                type="text" 
                                                class="form-control round" 
                                                id="email"
                                                formControlName="email" 
                                                (ngModelChange)="onFieldChange()"
                                                [maxlength]="250" 
                                                [required]="condionalDeObrigatoriedadeContatos()"
                                                [ngClass]="{'is-invalid': formGroupPME.controls['email'].errors && isFormSubmited}"/>
                                            <div 
                                                *ngIf="formGroupPME.controls['email'].errors?.['required'] && isFormSubmited"
                                                class="invalid-feedback">
                                                Campo obrigatório
                                            </div>
                                            <div 
                                                *ngIf="formGroupPME.controls['email'].errors?.['pattern'] && isFormSubmited"
                                                class="invalid-feedback">
                                                E-mail inválido
                                            </div>
                                        </div>
                                        <!-- Estado -->
                                        <div class="form-group col-md-3 mb-1">
                                            <label for="idEstado">Estado </label>
                                            <ng-select 
                                                [multiple]="false"
                                                [loading]="false" 
                                                [closeOnSelect]="true" 
                                                [searchable]="true"
                                                notFoundText="Nenhum registro localizado" 
                                                (change)="changeEstado($event)"
                                                class="round shadow" 
                                                [ngClass]="{'campo-obrigatorio': formGroupPME.controls['idEstado'].errors && isFormSubmited}"
                                                formControlName="idEstado">
                                                <ng-option *ngFor="let estado of listaEstados" [value]='estado'>
                                                    {{ estado.NomeEstado }}
                                                </ng-option>
                                            </ng-select>
                                            <div 
                                                *ngIf="formGroupPME.controls['idEstado'].errors?.['required'] && isFormSubmited"
                                                class="invalid-feedback d-block">
                                                Campo obrigatório
                                            </div>
                                        </div>
                                        <!-- Cidade -->
                                        <div class="form-group col-md-3 mb-1">
                                            <label for="idCidade ">Cidade </label>
                                            <ng-select 
                                                [multiple]="false"
                                                [loading]="false"
                                                [closeOnSelect]="true" 
                                                [searchable]="true"
                                                (change)="changeCidade($event)"
                                                notFoundText="Nenhum registro localizado" 
                                                class="round shadow" 
                                                [ngClass]="{'campo-obrigatorio': formGroupPME.controls['idCidade'].errors && isFormSubmited}"
                                                formControlName="idCidade">
                                                <ng-option *ngFor="let cidade of listaCidades" [value]='cidade'>
                                                    {{ cidade.NomeCidade }}
                                                </ng-option>
                                            </ng-select>
                                            <div 
                                                *ngIf="formGroupPME.controls['idCidade'].errors?.['required'] && isFormSubmited"
                                                class="invalid-feedback d-block">
                                                Campo obrigatório
                                            </div>
                                        </div>
                                        <!-- Preferência de Contato -->
                                        <div class="form-group col-md-3 mb-1" style="min-width: 220px;">
                                            <label for="preferenciaContato ">Preferência de Contato</label>
                                            <ng-select 
                                                class="round shadow" 
                                                [multiple]="false" 
                                                [searchable]="false"
                                                [loading]="false"
                                                [closeOnSelect]="true" 
                                                formControlName="preferenciaContato" >
                                                <ng-option [value]="'ligacao'">Ligação</ng-option>
                                                <ng-option [value]="'whatsApp'">WhatsApp</ng-option>
                                                <ng-option [value]="'e-mail'">E-mail</ng-option>
                                            </ng-select>  
                                        </div>
                                        <!-- Quantidade de Funcionários -->
                                        <h4 class="form-section col-sm-12 col-md-12 mt-2 preto-geia text-center text-qnt-funcionarios">
                                            ESTAMOS QUASE LÁ! INFORME A <b>QUANTIDADE DE FUNCIONÁRIOS</b> EM CADA FAIXA ETÁRIA.
                                        </h4>
                                        <div class="row justify-content-center">
                                            <div class="col-md-12">
                                                <div class="row justify-content-center">                                           
                                                    <!-- De 00 a 18 anos -->
                                                    <div class="form-group mb-1 col-sm-12 col-md-2">
                                                        <label for="funcionarios00a18">De 00 a 18 anos</label>
                                                        <input 
                                                        (ngModelChange)="onFieldChange()" 
                                                        type="number" 
                                                        class="form-control round"
                                                        id="funcionarios00a18" 
                                                        formControlName="funcionarios00a18"  
                                                        min="0"
                                                        max="150" 
                                                        oninput="if (this.value > 150) { this.value = ''; } else { this.value = this.value.replace(/[^0-9]/g, ''); }"> 
                                                    </div>
                                                    <!-- De 19 a 23 anos -->
                                                    <div class="form-group mb-1 col-sm-12 col-md-2">
                                                        <label for="funcionarios19a23">De 19 a 23 anos</label>
                                                        <input 
                                                        (ngModelChange)="onFieldChange()" 
                                                        type="number" 
                                                        class="form-control round"
                                                        id="funcionarios19a23" 
                                                        formControlName="funcionarios19a23" 
                                                        min="0" 
                                                        max="150" 
                                                        oninput="if (this.value > 150) { this.value = ''; } else { this.value = this.value.replace(/[^0-9]/g, ''); }"> 
                                                    </div>
                                                    <!-- De 24 a 28 anos -->
                                                    <div class="form-group mb-1 col-sm-12 col-md-2">
                                                        <label for="funcionarios24a28">De 24 a 28 anos</label>
                                                        <input 
                                                        (ngModelChange)="onFieldChange()" 
                                                        type="number" 
                                                        class="form-control round"
                                                        id="funcionarios24a28" 
                                                        formControlName="funcionarios24a28"  
                                                        min="0" 
                                                        max="150" 
                                                        oninput="if (this.value > 150) { this.value = ''; } else { this.value = this.value.replace(/[^0-9]/g, ''); }"> 
                                                    </div>
                                                    <!-- De 29 a 33 anos -->
                                                    <div class="form-group mb-1 col-sm-12 col-md-2">
                                                        <label for="funcionarios29a33">De 29 a 33 anos</label>
                                                        <input 
                                                        (ngModelChange)="onFieldChange()" 
                                                        type="number" 
                                                        class="form-control round"
                                                        id="funcionarios29a33" 
                                                        formControlName="funcionarios29a33" 
                                                        min="0"  
                                                        max="150" 
                                                        oninput="if (this.value > 150) { this.value = ''; } else { this.value = this.value.replace(/[^0-9]/g, ''); }"> 
                                                    </div>
                                                    <!-- De 34 a 38 anos -->
                                                    <div class="form-group mb-1 col-sm-12 col-md-2">
                                                        <label for="funcionarios34a38">De 34 a 38 anos</label>
                                                        <input 
                                                        (ngModelChange)="onFieldChange()" 
                                                        type="number" 
                                                        class="form-control round"
                                                        id="funcionarios34a38" 
                                                        formControlName="funcionarios34a38"  
                                                        min="0"
                                                        max="150" 
                                                        oninput="if (this.value > 150) { this.value = ''; } else { this.value = this.value.replace(/[^0-9]/g, ''); }"> 
                                                    </div>
                                                </div>
                                                <div class="row justify-content-center">
                                                    <!-- De 39 a 43 anos -->
                                                    <div class="form-group mb-1 col-sm-12 col-md-2">
                                                        <label for="funcionarios39a43">De 39 a 43 anos</label>
                                                        <input 
                                                        (ngModelChange)="onFieldChange()" 
                                                        type="number" 
                                                        class="form-control round"
                                                        id="funcionarios39a43" 
                                                        formControlName="funcionarios39a43"  
                                                        min="0"
                                                        max="150" 
                                                        oninput="if (this.value > 150) { this.value = ''; } else { this.value = this.value.replace(/[^0-9]/g, ''); }"> 
                                                    </div>
                                                    <!-- De 44 a 48 anos -->
                                                    <div class="form-group mb-1 col-sm-12 col-md-2">
                                                        <label for="funcionarios44a48">De 44 a 48 anos</label>
                                                        <input 
                                                        (ngModelChange)="onFieldChange()" 
                                                        type="number" 
                                                        class="form-control round"
                                                        id="funcionarios44a48" 
                                                        formControlName="funcionarios44a48"  
                                                        min="0"
                                                        max="150" 
                                                        oninput="if (this.value > 150) { this.value = ''; } else { this.value = this.value.replace(/[^0-9]/g, ''); }"> 
                                                    </div>
                                                    <!-- De 49 a 53 anos -->
                                                    <div class="form-group mb-1 col-sm-12 col-md-2">
                                                        <label for="funcionarios49a53">De 49 a 53 anos</label>
                                                        <input 
                                                        (ngModelChange)="onFieldChange()" 
                                                        type="number" 
                                                        class="form-control round"
                                                        id="funcionarios49a53" 
                                                        formControlName="funcionarios49a53"  
                                                        min="0"
                                                        oninput="if (this.value > 150) { this.value = ''; } else { this.value = this.value.replace(/[^0-9]/g, ''); }"> 
                                                    </div>
                                                    <!-- De 54 a 58 anos -->
                                                    <div class="form-group mb-1 col-sm-12 col-md-2">
                                                        <label for="funcionarios54a58">De 54 a 58 anos</label>
                                                        <input 
                                                        (ngModelChange)="onFieldChange()" 
                                                        type="number" 
                                                        class="form-control round"
                                                        id="funcionarios54a58" 
                                                        formControlName="funcionarios54a58"  
                                                        min="0"
                                                        oninput="if (this.value > 150) { this.value = ''; } else { this.value = this.value.replace(/[^0-9]/g, ''); }"> 
                                                    </div>
                                                    <!-- De + de 59 anos -->
                                                    <div class="form-group mb-1 col-sm-12 col-md-2">
                                                        <label for="funcionariosMais59">De + de 59 anos</label>
                                                        <input 
                                                        (ngModelChange)="onFieldChange()" 
                                                        type="number" 
                                                        class="form-control round"
                                                        id="funcionariosMais59" 
                                                        formControlName="funcionariosMais59"  
                                                        min="0"
                                                        oninput="if (this.value > 150) { this.value = ''; } else { this.value = this.value.replace(/[^0-9]/g, ''); }"> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Botão -->
                                        <div class="col-sm-12 col-md-12 mt-2 text-center" >
                                            <button
                                                type="button"
                                                (click)="onReceberCotacao()"
                                                class="btn cursor-pointer btn-round btn-success-geia white btn-min-width box-shadow-4 mr-1 mb-1 btn-receber-cotacao ">
                                                RECEBER COTAÇÃO
                                          </button>
                                        </div>
                                    </div>
                                </div>
                            </form>                                       
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <section class="feature-section bg-geia-azul">
        <div class="container">
            <div class="row justify-content-center service-looop" >
                <div class="col-lg-12" >
                    <div class="section-heading text-center mt-5">
                        <h2 class="title" style="color: white; font-weight: 700; font-size: 1.8em !important;"> Aqui, você e sua empresa
                            contam com a consultoria<br> especializada da Géia 
                        </h2>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-10" >
                    <div data-wow-delay="0.3s" class="iconic-box-two mt-30 wow fadeInUp bg-geia-azul">
                        <div class="icon"><img width="50px"
                            src="../../../../assets/app-assets/images/icones-geia/conferencia-w.png">
                        </div>
                        <h4 class="title-geia text-white m-t-title"><b>Envio</b> <p>das faturas</p> </h4>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-10"  >
                    <div class="iconic-box-two mt-30 wow fadeInUp bg-geia-azul">
                        <div class="icon"><img width="50px"
                            src="../../../../assets/app-assets/images/icones-geia/intemediacao-w.png" class="cursor-pointer">
                        </div>
                        <h4 class="title-geia text-white m-t-title"><b>Intermediação de negociações</b> <p> junto à operadora</p></h4>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-10" >
                    <div data-wow-delay="0.5s" class="iconic-box-two mt-30 wow fadeInUp bg-geia-azul">
                        <div class="icon"><img width="50px" src="../../../../assets/app-assets/images/icones-geia/rh-w.png"
                            class="cursor-pointer">
                        </div>
                        <h4 class="title-geia text-white m-t-title"><b>Suporte na</b> <p>movimentação cadastral</p> </h4>
                    </div>
                </div> 
                <div class="col-lg-4 col-md-6 col-sm-10" >
                    <div data-wow-delay="0.6s" class="iconic-box-two mt-30 wow fadeInUp bg-geia-azul"
                        >
                        <div class="icon"><img width="50px" src="../../../../assets/app-assets/images/icones-geia/agendamento-w.png"
                            class="cursor-pointer">
                        </div>
                        <h4 class="title-geia text-white m-t-title"><b>Agendamento</b>  <p>de exames e consultas</p></h4>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-10">
                    <div data-wow-delay="0.6s" class="iconic-box-two mt-30 wow fadeInUp bg-geia-azul">
                        <div class="icon"><img width="50px"
                            src="../../../../assets/app-assets/images/icones-geia/gestao-saude-branco.png" class="cursor-pointer">
                        </div>
                        <h4 class="title-geia text-white m-t-title"><b>Programa de Saúde </b><p>personalizado</p></h4>
                    </div>
                </div>
            </div>
        </div>  
    </section>
    <app-portal-footer> </app-portal-footer>
</block-ui>